document.addEventListener('DOMContentLoaded', function() {

  // =========================================================
  // PART 1: Collection Page (Swatch Hover/Click)
  // =========================================================
  var swatches = document.querySelectorAll('.product-block .cc-swatches a');

  function updateCollectionPrice(element) {
    var productBlock = element.closest('.product-block');
    if (!productBlock) return;

    // If product-level sale is active on this card, skip variant-level updates
    if (productBlock.querySelector('[data-product-sale-active]')) return;

    var priceElem = productBlock.querySelector('[data-price-element]');
    var textElem = productBlock.querySelector('[data-sale-text-element]');

    if (!priceElem) return;

    if (!textElem) return;

    var metaText = element.getAttribute('data-meta-text');
    var metaStrike = element.getAttribute('data-meta-strike') === 'true';

    if (metaStrike) {
      priceElem.classList.add('price-strikethrough');
    } else {
      priceElem.classList.remove('price-strikethrough');
    }

    textElem.textContent = metaText || '';
  }

  swatches.forEach(function(swatch) {
    swatch.addEventListener('mouseenter', function() { updateCollectionPrice(this); });
    swatch.addEventListener('click', function() { updateCollectionPrice(this); });
  });


  // =========================================================
  // PART 2: Product Detail Page (Variant Updates)
  //
  // IMPORTANT: theme.js fires updatePrice() on every variant
  // change (including initial page load via 'firstrun'). That
  // function wipes the entire innerHTML of .price-area. So any
  // sale pricing HTML rendered by Liquid is destroyed before
  // the user sees it.
  //
  // The fix: sale data attributes live on the .price-area div
  // itself (which survives the innerHTML wipe). This handler
  // runs AFTER theme.js (cc-variant-updated fires after
  // updatePrice), and rebuilds the sale pricing HTML.
  // =========================================================

  // Shared money formatter
  function formatMoney(cents) {
    var format = (window.theme && window.theme.money_format_with_code_preference)
      ? window.theme.money_format_with_code_preference
      : '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  // Show the "discount will apply" CTA subtext(s) only when the selected
  // variant/product is actually on sale. Keeps the promise off non-sale
  // colors and off products that aren't on sale. Mirrors the server-side
  // gate in main-product.liquid so initial load and variant changes agree.
  function updateCtaSubtext(variant) {
    var subtextEls = document.querySelectorAll('[data-cta-subtext]');
    if (!subtextEls.length) return;

    var onSale = false;

    // Whole-product sale: every variant is on sale.
    if (document.querySelector('.price-area[data-product-sale-active]')) {
      onSale = true;
    } else {
      subtextEls.forEach(function (el) {
        if (el.getAttribute('data-cta-whole-sale') === 'true') onSale = true;
      });
    }

    // Native compare-at on the selected variant.
    if (!onSale && variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
      onSale = true;
    }

    // Per-color sale metafield (price strikethrough) on the selected variant.
    if (!onSale && variant) {
      var lk = document.querySelector('.variant-metafield-lookup');
      if (lk) {
        try {
          var m = (JSON.parse(lk.innerHTML) || {})[variant.id];
          if (m && m.strike) onSale = true;
        } catch (e) {}
      }
    }

    subtextEls.forEach(function (el) {
      el.style.display = onSale ? '' : 'none';
    });
  }

  if (typeof jQuery !== 'undefined') {

    jQuery(window).on('cc-variant-updated', function(e, args) {
      var variant = args.variant;
      if (!variant) return;

      // --- CTA subtext: gate on the selected variant's sale state ---
      updateCtaSubtext(variant);

      // --- Sticky CTA: always update variant name and image on variant change ---
      var stickyVariant = document.querySelector('[data-sticky-pdp-variant]');
      if (stickyVariant && variant.title) {
        stickyVariant.textContent = ' \u00b7 ' + variant.title;
      }
      var stickyImg = document.querySelector('[data-sticky-pdp-image]');
      if (stickyImg && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        src = src.replace(/(\.(?:jpg|jpeg|png|gif|webp))/, '_96x96_crop_center$1');
        stickyImg.src = src;
      }

      // --- Product-level sale: rebuild pricing inside .price-area ---
      // Data attributes are on the .price-area div itself, so they
      // survive theme.js wiping the innerHTML.
      var priceArea = document.querySelector('.price-area[data-product-sale-active]');
      if (priceArea) {
        var percentOff = parseInt(priceArea.getAttribute('data-product-sale-percent-off'), 10) || 0;
        var fixedSalePrice = parseFloat(priceArea.getAttribute('data-product-sale-fixed-price')) || 0;
        var priceColor = priceArea.getAttribute('data-product-sale-price-color') || '#D83D9A';

        // Determine base price (what gets struck through)
        var basePrice = variant.price;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          basePrice = variant.compare_at_price;
        }

        // Determine sale price (fixed takes priority over percentage)
        var salePrice = 0;
        if (fixedSalePrice > 0) {
          salePrice = Math.round(fixedSalePrice * 100);
        } else if (percentOff > 0) {
          salePrice = Math.round(basePrice * (100 - percentOff) / 100);
        }

        // Build the HTML: sale price first, struck original second
        var html = '';

        if (salePrice > 0) {
          html += '<span class="product-sale-calculated theme-money" style="color:' + priceColor + ';font-weight:700;">' + formatMoney(salePrice) + '</span> ';
        }

        html += '<span class="product-sale-original theme-money">' + formatMoney(basePrice) + '</span>';

        priceArea.innerHTML = html;

        // Also update sticky CTA prices: sale price first, struck original second
        var stickyPrice = document.querySelector('[data-sticky-pdp-price]');
        if (stickyPrice) {
          var stickyHtml = '';
          if (salePrice > 0) {
            stickyHtml += '<span class="product-sale-calculated theme-money" style="color:' + priceColor + ';font-weight:700;">' + formatMoney(salePrice) + '</span> ';
          }
          stickyHtml += '<span class="product-sale-original theme-money">' + formatMoney(basePrice) + '</span>';
          stickyPrice.innerHTML = stickyHtml;
        }

        return; // Skip variant-level logic
      }

      // --- Variant-level sale logic ---
      var dataScript = document.querySelector('.variant-metafield-lookup');
      if (!dataScript) return;

      try {
        var metaData = JSON.parse(dataScript.innerHTML);
        var currentMeta = metaData[variant.id];

        if (currentMeta) {
          var variantPriceArea = document.querySelector('.product-detail__form .price-area');
          if (variantPriceArea) {
            var priceText = variantPriceArea.querySelector('.current-price, .price');

            if (priceText) {
              currentMeta.strike ? priceText.classList.add('price-strikethrough') : priceText.classList.remove('price-strikethrough');
            }

            var saleTextSpan = variantPriceArea.querySelector('.meta-sale-text-pdp');
            if (!saleTextSpan && currentMeta.text) {
              saleTextSpan = document.createElement('span');
              saleTextSpan.className = 'meta-sale-text-pdp';
              saleTextSpan.style.marginRight = '8px';
              saleTextSpan.style.fontWeight = 'bold';
              saleTextSpan.style.color = '#D83D9A';
              variantPriceArea.insertBefore(saleTextSpan, variantPriceArea.firstChild);
            }
            if (saleTextSpan) {
              saleTextSpan.textContent = currentMeta.text;
            }
          }

          var badgeSpan = document.querySelector('.variant-sale-label');
          if (badgeSpan) {
            if (currentMeta.label) {
              badgeSpan.textContent = currentMeta.label;
              badgeSpan.style.display = 'inline-block';
            } else {
              badgeSpan.style.display = 'none';
            }
          }

        }
      } catch(err) {
        console.error('Error parsing metafield data', err);
      }

      var stickyPrice = document.querySelector('[data-sticky-pdp-price]');
      if (stickyPrice && !document.querySelector('.price-area[data-product-sale-active]')) {
        var sMeta = null;
        var sLookup = document.querySelector('.variant-metafield-lookup');
        if (sLookup) { try { sMeta = (JSON.parse(sLookup.innerHTML) || {})[variant.id]; } catch (e) {} }
        var sHtml;
        if (sMeta && sMeta.strike && sMeta.text) {
          sHtml = '<span class="meta-sale-text theme-money" style="color:#D83D9A;font-weight:700;margin-right:6px;">' + sMeta.text + '</span>'
                + '<span class="theme-money price-strikethrough">' + formatMoney(variant.price) + '</span>';
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          sHtml = '<span class="theme-money" style="color:#D83D9A;font-weight:700;">' + formatMoney(variant.price) + '</span> '
                + '<span class="product-sale-original theme-money">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          sHtml = '<span class="theme-money">' + formatMoney(variant.price) + '</span>';
        }
        stickyPrice.innerHTML = sHtml;
      }
    });
  }


  // =========================================================
  // PART 3: Sticky PDP CTA Bar
  // =========================================================

  var stickyBar = document.querySelector('[data-sticky-pdp-cta]');
  if (stickyBar) {
    var sectionEl = stickyBar.closest('.section-product-template');
    if (sectionEl) {
      sectionEl.style.paddingBottom = '80px';
    }

    var buyButtons = document.querySelector('.product-detail__form__action');

    if (buyButtons) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            var rect = buyButtons.getBoundingClientRect();
            if (rect.top < 0) {
              stickyBar.classList.add('is-visible');
            } else {
              stickyBar.classList.remove('is-visible');
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      observer.observe(buyButtons);
    }

    var stickyAddBtn = stickyBar.querySelector('[data-sticky-pdp-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var mainAddBtn = document.querySelector('.product-detail__form__action button[type="submit"][name="add"]');
        if (mainAddBtn) {
          mainAddBtn.click();
          var formArea = document.querySelector('.product-detail__form');
          if (formArea) {
            formArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }
  }
});
